import { CollectionItem } from "@/Common/Models/CollectionItem";
import { Guid } from "@/Common/Models/Guid";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";

class LocalEvent {
    public EmitChange: boolean;
    public EventId: string;
    public PatientId: Guid;

    private dataCollection: CollectionItem<string, any>[];
    private eventId: number;

    constructor(eventId: number) {
        this.eventId = eventId;
        this.dataCollection = [];
        this.EventId = String(new Date().getTime());
        this.PatientId = null;
        this.EmitChange = true;
    }

    public AddItem(key: string, value: any): this {
        if (!key)
            throw new TypeError("Key is required");
        if (key === "")
            throw new TypeError("Key is required");

        if (this.HasItem(key)) {
            this.RemoveItem(key);
            this.AddItem(key, value);
        }
        else {
            this.dataCollection.push({ key, value });
        }

        return this;
    }

    public HasItem(key: string): boolean {
        return this.IndexOf(key) >= 0;
    }

    private IndexOf(key: string): number {
        if (this.dataCollection == null)
            return -1;
        if (this.dataCollection.length === 0)
            return -1;

        for (let i = 0; i < this.dataCollection.length; i++) {
            if (this.dataCollection[i].key === key)
                return i;
        }
        return -1;
    }

    public get Operation(): number {
        return this.eventId;
    }

    private RemoveItem(key: string): void {
        let idx = this.IndexOf(key);
        if (idx >= 0) {
            this.dataCollection.splice(idx, 1);
        }
    }

    public Get<T>(key: string): T {
        let idx = this.IndexOf(key);
        if (idx < 0)
            return null;
        else {
            return this.dataCollection[idx].value;
        }
    }

    public static Dispatch(operation: number, items?: KeyValuePair<string, any>[] | object | null | undefined): void {
        let op = new LocalEvent(operation);

        if (items == null) {
            LocalEventDispatcher.dispatch(op);
            return;
        }

        if (items instanceof Array) {
            items.forEach(kvp => op.AddItem(kvp.Key, kvp.Value));
        }
        else {
            for (const property in items) {
                op.AddItem(property, items[property]);
            }
        }

        LocalEventDispatcher.dispatch(op);
    }

    public CollectionItems(): CollectionItem<string, any>[] {
        return this.dataCollection.filter(() => true);
    }
}

export { LocalEvent };
